module.exports = __webpack_public_path__ + "img/red_060.ce0042ff.png";